import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  constructionSelector,
  (construction) => ({
    available: [...construction.available.moisture_protection],
    info: construction.info.moisture_protection,
    loaded: construction.parameters_loaded,
    selected: construction.selected.moisture_protection
  })
);
